export default {
  common: {
    help: "Avez-vous des questions à propos de votre réclamation ?",
    call: "Appelez-nous au",
    phone: "1 800 549 7227",
    phoneLink: "tel:18005497227",
    previous: "Précédent",
    next: "Suivant",
    cancel: "Annuler",
    ok: "OK",
    cancelTitle: "Avertissement",
    cancelMsg:
      "Vous vous apprêtez à fermer le formulaire. Toutes les informations saisies seront perdues. Souhaitez-vous continuer?",
    submit: "Envoyer",
    error: "Merci de corriger les erreurs sur la page avant de continuer",
    errorSubmit: "Une erreur s'est produite en envoyant votre réclamation. Veuillez imprimer et/ou sauvegarder cette page et appeler notre Service à la clientèle au 1 800 549 7227"
  },
  landing_page: {
    header1: "Faire une réclamation",
    header2: "Les réclamations suivantes peuvent être soumises en ligne :",
    disabilityLink: "Invalidité",
    header3:
      "Pour soumettre les réclamations ci-dessous, contactez notre Service de réclamations au ",
    lifeLink: "Décès",
    ciLink: "Maladie grave",
    empLink: "Perte d’emploi involontaire",
    header4: "Autres méthodes de réclamation",
    subheader1: "Contactez le Service de réclamations",
    paragraph1:
      "Nous vous accompagnerons dans votre démarche pour soumettre votre réclamation.",
    paragraph2: "Contactez-nous au ",
    subheader2: "Complétez un formulaire",
    paragraph3:
      "Complétez les formulaires nécessaires et retournez-les avec tout document demandé.",
    paragraph4: "Formulaires",
    subheader3: "Faire le suivi d'une réclamation",
    trackerLink: "Accédez à votre page de suivi >",
    disForm: "Formulaire Invalidité",
    lifeForm: "Formulaire Décès",
    ciForm: "Formulaire Maladie grave",
    emailSecurityMsg: "Nous vous rappelons que le courriel est un mode non sécurisé de communication qui devrait être utilisé uniquement pour transmettre des informations non confidentielles.",
    faqPdf: "FAQ – Assurance Crédit-invalidité"
  },
  section_intro: {
    header1: "Faire une Réclamation",
    paragraph1:
      "Ce formulaire permet de faire une réclamation d’assurance - invalidité en ligne.  Prévoyez environ 15 minutes pour remplir ce formulaire. Si vous voulez soumettre votre réclamation par téléphone, composez le",
    paragraph2: "Nous vous demanderons des renseignements sur:",
    list1: "Le concessionnaire automobile où vous avez obtenu votre assurance",
    list2:
      "L’institution financière où votre contrat de prêt ou de location est administré",
    list3: "La condition médicale causant votre invalidité",
    list4: "Dates où vous avez nécessité une attention médicale",
    list5: "Le nom de votre médecin et ses informations de contact",
    list6: "Renseignements sur votre emploi",
    paragraph3: "Ayez ces informations prêtes avant de commencer"
  },
  section_contact: {
    paragraph1: "Merci d’appeler notre Service à la Clientèle au",
    header2: "Adresse",
    paragraph2:
      "Vous recevrez un accusé de réception après l’envoi de votre réclamation."
  },
  section_certificateFinancial: {
    header2: "Concessionnaire Automobile",
    header3: "Informations sur la Location ou le Prêt"
  },
  section_disability: {
    header2: "Consultation médicale liée à cette condition",
    header3: "Historique médical"
  },
  section_accident: {
  },
  section_occupation: {
    header2: "À Propos de Votre Travail Autonome"
  },
  section_comments: {
  },
  section_summary: {
    header1:  "Sommaire des Informations",
    section1: "Modifier la Section Contact",
    section2: "Modifier la Section Certificat",
    section3: "Modifier la Section Invalidité",
    section4: "Modifier la Section Accident",
    section5: "Modifier la Section Emploi",
    section6: "Modifier la section Commentaire"
  },
  section_confirmation: {
    header1: "Confirmation",
    header2: "Nous avons reçu votre réclamation.",
    paragraph1:
      "Vous allez recevoir un autre courriel contenant votre numéro de suivi et toute information relative à votre réclamation."
  }
};
